<h1 class="u-sr-only">{{ 'Booking.Title.Book' | translate }}</h1>
<div class="o-grid o-grid--wrap">
	<div class="o-grid__cell o-grid__cell--w-100 u-no-p@up-to-md">
		<form name="vm.form" #mainForm="ngForm" class="c-form">
			<section class="c-section c-section--open" [ngClass]="{'c-section--error': vm.submitted && vm.nothingSelected}">
				<div class="c-section__content">
					<h2 class="c-text c-text--heading c-text--xl u-osb-lg u-hidden@up-to-md" [ngClass]="{'c-text--s3': vm.submitted && vm.nothingSelected}">
						{{vm.title}}
					</h2>
					<div class="c-card" [ngClass]="{'c-card--error': vm.submitted && vm.nothingSelected}">
						<div class="c-content c-content--xxl">
							<div class="o-grid o-grid--center-h">
								<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
									<div class="c-form__group u-no-m" [ngClass]="{ 'c-form__group--error': vm.submitted && vm.nothingSelected }">
										<label for="problem" class="c-form__label c-form__label--light">
											{{ 'Booking.Instant.SelectOneOrMultipleOptions' | translate }}
										</label>
										<div class="c-tags__wrapper">
											<div *ngFor="let answer of vm.answers ; let $index=index"
												 [ngClass]="{'c-tag--selected': answer.isSelected}"
												 (click)="vm.onAnswerClick($event, answer)"
												 style="display: table-cell; height: auto"
												 class="c-tag">
												<span *ngIf="vm.user?.previsitUser" id="answerLabelForPrevisit{{$index}}">{{answer.text}}</span>
												<span *ngIf="!vm.user?.previsitUser" id="answerLabel{{$index}}">{{answer.text}}</span>
											</div>
										</div>
										<div *ngIf="vm.isInputTextAreaShown" [ngClass]="{'c-form__group--error': vm.submitted && otherProblem.invalid}">
											<label for="problem" class="c-form__label c-form__label--light">{{ 'Booking.Instant.Mental_Problem' | translate }}</label>
											<textarea name="problem" id="problem" rows="6" class="c-form__input c-form__input" [(ngModel)]="vm.problem" #otherProblem="ngModel" required maxlength="{{vm.problemMaxLength}}"></textarea>
											<p class="c-text c-text--sm c-text--gray c-text--right" [ngClass]="{ 'c-text--s3': (vm.submitted && otherProblem.invalid) }">{{ otherProblem?.value?.length || 0 }} / {{ vm.problemMaxLength }}</p>
											<item-form-error *ngIf="vm.submitted && otherProblem.invalid" [fieldName]="'Booking.Problem_Description_Short' | translate" [error]="otherProblem.errors" style="margin-top: -10px"></item-form-error>
										</div>
									</div>
								</div>
							</div>
						</div>
						<loader-overlay *ngIf="vm.isProcessing"></loader-overlay>
					</div>
					<div class="c-content u-no-pb u-no-ph@md-and-up" *ngIf="vm.isInitialized">
						<div class="o-grid">
							<div class="o-grid__cell u-hidden@up-to-md"></div>
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p">
								<button id="formSubmitButton" type="button" class="c-button c-button--s2 c-button--fit c-button--lg"
												(click)="vm.handleFormSubmit(mainForm)" [disabled]="vm.isProcessing">
									{{ 'Common.Next' | translate }}
								</button>
							</div>
						</div>
					</div>
				</div>
			</section>
		</form>
	</div>
</div>
